<script lang="ts">
    import { trans } from '$assets/shop-translator.js';
    import { ariaKeyDownA11yHandler } from '$common/utils/ariaKeyDownA11y';
    import cn from '$common/utils/cn';

    export let label: string;
    export let subLabel: string | undefined = undefined;
    export let onToggleCheck: () => void | undefined = () => {};
    export let labelClass: string | undefined = '';
    export let containerClass: string | undefined = '';
    export let isChecked: boolean = false;
    export let isDisabled: boolean = false;
</script>

{#if isDisabled}
    <div
        class={cn('flex gap-s px-m py-s', containerClass)}
        data-test="checkbox"
        title={trans('search.filter.sidebar.option_disabled')}
        aria-label={trans('search.filter.sidebar.option_disabled')}
    >
        <div>
            <input type="checkbox" checked={isChecked} disabled />
        </div>
        <div class="flex flex-col items-center">
            <div class={cn('text-content-quiet', labelClass)}>{label}</div>
            {#if subLabel}
                <div class="text-xs text-content-quiet">{subLabel}</div>
            {/if}
        </div>
    </div>
{:else}
    <div
        class={cn('flex cursor-pointer gap-s p-s', containerClass)}
        on:click={onToggleCheck}
        role="button"
        tabindex="0"
        {...ariaKeyDownA11yHandler(onToggleCheck)}
        data-test="checkbox"
    >
        <div>
            <input type="checkbox" checked={isChecked} />
        </div>
        <div class="flex flex-col">
            <div class={labelClass}>{label}</div>
            {#if subLabel}
                <div class="text-xs text-content-quiet">{subLabel}</div>
            {/if}
        </div>
    </div>
{/if}
